import React from 'react';

export default function MostraStatus({status, lang}) {

  switch(lang){
    case 'ptbr':
      return retornaStatusPtbr(status)
    case 'en':
      return retornaStatusEn(status)
    case 'es':
      return retornaStatusEs (status)
    default:
      return retornaStatusPtbr(status)
  }
}

function retornaStatusPtbr (status){
  switch(status){
    case 'NOVO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-sucess text-white rounded">Novo Relato</div>
    case 'EM_ANDAMENTO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-alerta text-black rounded">Em andamento</div>
    case 'CONCLUIDO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-secondary text-white rounded">Concluído</div>
    case 'AGUARDANDO_RESPOSTA':
      return <div className="py-2 px-2 mx-4 font-semibold bg-danger text-white rounded">Aguardando Resposta</div>
    case 'FINALIZADO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-sucess text-white rounded">Concluída</div>
    case 'NAO_REALIZADO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-danger text-white rounded">Não realizado</div>
    default:
      break
  }
}

function retornaStatusEn (status){
  switch(status){
    case 'NOVO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-sucess text-white rounded">New Report</div>
    case 'EM_ANDAMENTO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-alerta text-black rounded">In progress</div>
    case 'CONCLUIDO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-secondary text-white rounded">Completed</div>
    case 'AGUARDANDO_RESPOSTA':
      return <div className="py-2 px-2 mx-4 font-semibold bg-danger text-white rounded">Waiting for response</div>
    default:
      break
  }
}

function retornaStatusEs (status){
  switch(status){
    case 'NOVO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-sucess text-white rounded">Nuevo informe</div>
    case 'EM_ANDAMENTO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-alerta text-black rounded">En curso</div>
    case 'CONCLUIDO':
      return <div className="py-2 px-2 mx-4 font-semibold bg-secondary text-white rounded">Terminado</div>
    case 'AGUARDANDO_RESPOSTA':
      return <div className="py-2 px-2 mx-4 font-semibold bg-danger text-white rounded">Esperando respuesta</div>
    default:
      break
  }
}